import React ,{useEffect}from "react";

import Login from "./components/login/Login";
import ForgotPassword from "./components/login/ForgotPassword";
import ForgotPasswordOtp from "./components/login/ForgotPasswordOtp";
import NewPassowrd from "./components/login/EnterNewPass";
import { Router, useNavigate, Navigate } from "react-router-dom";

import { Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

const UnAuthenticated = () => {

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password-otp" element={<ForgotPasswordOtp />} />
        <Route path="/newPassword" element={<NewPassowrd />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};
export default UnAuthenticated;
